module.exports = __webpack_public_path__ + "img/0-120.78b35d8b.jpg";